import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useTheme } from '../utils/ThemeState'

export default function Icon({ name, className, size = 1, color, ...rest }) {
  const theme = useTheme()
  const { icons, defaultColor } = useIcons() || {}
  if (!icons || !theme) return null
  const Component = icons[name]
  if (!Component) return null

  const iconColor = color || defaultColor || 'currentColor'

  const props = {
    className: classnames('icon', className),
    style: {
      width: `${size}em`,
      height: `${size}em`,
      verticalAlign: 'middle',
      fill: theme.colors[iconColor] || iconColor,
    },
  }

  return <Component {...rest} {...props} />
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
}

/**
 * Icon Theme Context
 */

const IconThemeContext = React.createContext()

export function IconThemeProvider({ children, icons, defaultColor = 'currentColor' }) {
  return (
    <IconThemeContext.Provider
      value={{
        icons,
        defaultColor,
      }}
      children={children}
    />
  )
}

IconThemeProvider.propTypes = {
  icons: PropTypes.object.isRequired,
}

export function useIcons() {
  return useContext(IconThemeContext)
}
